export const css = {
    root: '_1H4GURez',
    wrapper: '_3BNqnMx_',
    field: '_1MgDJVmS',
    bar: 'u8FksHTF',
    ' _key': 'dashboard-widgets/viz'
};
export default css;
